import * as React from 'react'

function SvgCateKocowa(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M20.818 3.27c.54 0 .98.44.98.98v16.216c0 .54-.44.98-.98.98H2.98c-.54 0-.98-.44-.98-.98V4.25c0-.54.44-.98.98-.98zm0 .77H2.98a.213.213 0 00-.21.21v16.216c0 .114.096.21.21.21h17.838c.113 0 .21-.096.21-.21V4.25a.212.212 0 00-.21-.21zM6.656 18.07v1.039H4.168v-1.04h2.488zm4.324 0v1.039H8.493v-1.04h2.487zm4.324 0v1.039h-2.487v-1.04h2.487zm4.325 0v1.039H17.14v-1.04h2.488zm-9.315-8.584c.093 0 .202.04.315.114l3.542 2.334c.176.116.273.266.273.424 0 .158-.097.308-.273.424l-3.542 2.334a.598.598 0 01-.315.114c-.188 0-.3-.167-.3-.445V9.931c0-.278.112-.445.3-.445zM6.656 5.608v1.038H4.168V5.608h2.488zm4.324 0v1.038H8.493V5.608h2.487zm4.324 0v1.038h-2.487V5.608h2.487zm4.325 0v1.038H17.14V5.608h2.488z" />
    </svg>
  )
}

export default SvgCateKocowa
